export default "__VITE_ASSET__CHYvU5L3__"